<script>
    import { createEventDispatcher } from 'svelte'
    import { scale, fade } from 'svelte/transition'
    import { expoIn } from 'svelte/easing'
    import TouchButton from '../TouchButton/TouchButton.svelte'


    export let message = 'We\'re sorry, apparently something went wrong.'
    const dispatch = createEventDispatcher ()
</script>

<div class="Error" transition:fade={{ duration: 200 }}>
    <div class="spinner-holder">
        <div class="spinner " transition:scale={{ delay: 200, start: .2, duration: 200 }}>
            <i class="far fa-times"></i>
        </div>
        <div class="message">
            <div class="head">Application Error</div>
            <div class="description">{message}</div>
        </div>
        <div class="ctrls">
            <TouchButton click={e => dispatch ('errordispose')}>Close</TouchButton>
        </div>
    </div>
</div>

<style>
    .Error {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 41;
        background-color: #fff;
    }
    .spinner-holder {
        position: absolute;
        width: 100%;
        top: 40%;
        transform: translateY(-50%);
        text-align: center;
    }
    .spinner {
        display: inline-block;
        width: 80px;
        height: 80px;
        line-height: 80px;
        text-align: center;
        color: #fff;
        background-color: #ff7675;
        font-size: 28px;
        border-radius: 50%;
        position: relative;
        -webkit-animation-duration: .3s;
        animation-duration: .3s;
    }
    .message {
        margin-top: 20px;
    }
    .message .head {
        font-size: 15px;
        font-weight: 600;
    }
    .message .description {
        font-size: 14px;
        color: #82adbb;
    }
    .ctrls {
        margin-top: 20px
    }
    .ctrls :global(button) {
        width: 50%;
    }
</style>